import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CNDepartment } from 'src/app/models/cndepartment';
import { SNUser } from 'src/app/models/snuser';
import { BecareService } from '../becare.service';
import { UserConfigService } from '../user-config.service';
import { map } from 'rxjs/operators';
import { ODBService } from '../odb.service';

@Injectable({
  providedIn: 'root'
})
export class UserDepartmentService {

  protected departmentsSource: BehaviorSubject<CNDepartment[]>;
  private allDepartments: CNDepartment[];

  constructor(private becare: BecareService, private userConfig: UserConfigService, private odb: ODBService) {
    this.departmentsSource = new BehaviorSubject([]);
    this.becare.authStatus().subscribe(status => {
      if (status === true) {
        this.loadDepartments();
      }
    });
  }

  public departments(): Observable<CNDepartment[]> {
    return this.departmentsSource.asObservable();
  }

  public loadDepartments(): void {
    this.becare.call('/' + this.userConfig.user.language + '/departments', [], '', 'get', 'departments', true)
    .subscribe(departments => {
      this.allDepartments = departments;
      this.departmentsSource.next(this.allDepartments);
    });
  }

  public addDepartment(name: string) {
    const newDep = new CNDepartment();
    newDep.setProperty('name_' + this.userConfig.user.language, name);
    this.becare.call('/' + this.userConfig.user.language + '/department', [], newDep, 'post', 'department', true)
    .subscribe(repartment => {
      this.allDepartments.push(repartment);
      this.departmentsSource.next(this.allDepartments);
    });
  }

  public updateDepartment(department: CNDepartment) {
    department.update().subscribe();
  }

  public userDepartments(user: SNUser): Observable<CNDepartment[]> {
    // tslint:disable-next-line:max-line-length
    return this.becare.call('/' + this.userConfig.user.language + '/user/' + user.id + '/departments', [], '', 'get', 'departments', true);
  }

  public removeDepartment(department: CNDepartment) {
    this.odb.removeItem(department).subscribe(removed => {
      this.loadDepartments();
    });
  }
}
